var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var utils = new CommonUtils();

var TableSettingsManager = Marionette.View.extend({
    template: require('../../templates/common/table-settings-manager.html'),
    table: {},


    ui: {
        saveReportSetting: '#save-report-setting',
        loadReportSetting: '#load-report-setting',
        savedFilters: '#saved-filters-module',
        newSettingNameSave: '#save-new-setting-name',
        newSettingName: '#new-setting-name',
        deleteSetting: '#delete-report-setting'
    },

    events: {
        'click @ui.saveReportSetting': 'onSaveReportSetting',
        'click @ui.loadReportSetting': 'onLoadReportSetting',
        'click @ui.newSettingNameSave': 'onSaveNewSettingName',
        'click @ui.deleteSetting': 'onDeleteSetting',
        'change @ui.savedFilters': 'onChangeSavedFilters'
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        var that = this;
        that.table = options.table;
    },

    onRender: function () {
        var that = this;
        this.ui.savedFilters.selectize({
            allowEmptyOption: true,
            inputClass: 'form-control selectize-input normal-width form-control',
            highlight: true,
            openOnFocus: true
        });
        that.asyncGetTableSettingsList();
    },

    asyncGetTableSettingsList: function () {
        var that = this;

        $.ajax({
            type: "GET",
            url: "/api/table-column-filter-preferences/names/" + that.table.reportTableName,
            statusCode: {
                200: function (response) {
                    if (response) {
                        var arrayLength = response.length;
                        for (var i = 0; i < arrayLength; i++) {
                            that.ui.savedFilters["0"].selectize.addOption({
                                value: response[i].id,
                                text: response[i].name
                            });
                        }
                    }
                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);

                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");

                },
                404: function (e) {
                    notificationsChannel.request('show:notification', e.responseText);
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
        return [];
    },

    onSaveReportSetting: function (e) {
        var that = this;
        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
            utils.showSpinner();
            that.table.tableFilterPreferences.settingName = that.ui.savedFilters["0"].selectedOptions["0"].value;
            $.ajax({
                type: "PUT",
                url: "/api/table-column-filter-preferences/name/" + that.table.reportTableName,
                data: JSON.stringify(that.table.tableFilterPreferences),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        utils.hideSpinner();
                        $.notify("Filters successfully saved", "success");
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                    utils.hideSpinner();
                }
            });
        }
        else {
            $.notify("Select filter setting name", "error");
        }
    },

    onSaveNewSettingName: function () {
        var that = this;
        utils.showSpinner();
        that.table.tableFilterPreferences.settingName = that.ui.newSettingName["0"].value;
        $.ajax({
            type: "POST",
            url: "/api/table-column-filter-preferences/name/" + that.table.reportTableName,
            data: JSON.stringify(that.table.tableFilterPreferences),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.ui.savedFilters["0"].selectize.addOption({
                        value: that.ui.newSettingName["0"].value,
                        text: that.ui.newSettingName["0"].value
                    });
                    that.ui.savedFilters["0"].selectize.addItem(that.ui.newSettingName["0"].value);
                    that.ui.newSettingName["0"].value = null;
                    $('#newSettingInListModal').modal('toggle');
                    $.notify("Filters successfully created", "success");
                }
            },
            error: function (e) {
                notificationsChannel.request('show:notification', e.responseText);
                utils.hideSpinner();
            }
        });

    },

    onLoadReportSetting: function (e) {
        var that = this;
        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
            var that = this;
            var url = "/api/table-column-filter-preferences/name/" + that.table.reportTableName + "?settingName=" + that.ui.savedFilters["0"].selectedOptions["0"].value;
            var method = "GET";

            utils.showSpinner();
            $.ajax({
                type: method,
                url: url,
                statusCode: {
                    200: function (response) {
                        if (response) {
                            that.table.tableFilterPreferences = response;
                        }
                        utils.hideSpinner();
                        that.triggerMethod('filters:loaded', response);

                    },
                    503: function (e) {
                        notificationsChannel.request('show:notification', e.responseJSON);

                    },
                    401: function (e) {
                        actionsChannel.request("redirect:to:login");

                    },
                    404: function (e) {
                        notificationsChannel.request('show:notification', e.responseText);
                    }
                },
                error: function (e) {
                    utils.hideSpinner();
                    console.log(e);
                }
            });
        }
        else {
            $.notify("Select filter setting name", "error");
        }
    },

    onChangeSavedFilters: function (e) {
        this.selectedTableFiltersId = e.target.selectedOptions["0"].value;
    },

    onDeleteSetting: function () {
        var that = this;
        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
            if (confirm("Are you sure?")) {
                var url = "/api/table-column-filter-preferences/name/" + that.table.reportTableName + "?settingName=" + that.ui.savedFilters["0"].selectedOptions["0"].value;
                var method = "DELETE";

                $.ajax({
                    type: method,
                    url: url,
                    statusCode: {
                        200: function (response) {
                            that.ui.savedFilters["0"].selectize.removeOption(that.ui.savedFilters["0"].selectedOptions["0"].value);
                            $.notify("Filters successfully removed", "success");
                        },
                        503: function (e) {
                            notificationsChannel.request('show:notification', e.responseJSON);

                        },
                        401: function (e) {
                            actionsChannel.request("redirect:to:login");

                        },
                        404: function (e) {
                            notificationsChannel.request('show:notification', e.responseText);
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            }
        } else
            $.notify("Select filter setting name", "error");
    }
});

module.exports = TableSettingsManager;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/table-settings-manager.js
// module id = 287
// module chunks = 0